module.exports = __webpack_public_path__ + "img/inputPage.9235c342.png";